export const translations = {
	'The report is created.': {
		no: 'Rapporten opprettet.',
	},
	'Select service to filter report data...': {
		no: 'Velg tjeneste for å filtrere rapportdata',
	},
	'First page': {
		no: 'Første side',
	},
	'Last page': {
		no: 'Siste side',
	},
	'The report is updated.': {
		no: 'Oppdateringen vellykket.',
	},
	'Generate report': {
		no: 'Generer rapport',
	},
	'Download in browser': {
		no: 'Last ned i nettleser',
	},
	'Send as email to': {
		no: 'Send på epost til',
	},
	'Wait for preview': {
		no: 'Vent for visning',
	},
	'When the report is generated it will be sent to': {
		no: 'Når rapporten er ferdig vil den bli sendt til',
	},
	'When the report is generated it will be downloaded in browser': {
		no: 'Når rapporten er generert vil den bli lastet ned i nettleseren',
	},
	'This quarter': {
		no: 'Dette kvartalet',
	},
	'This month': {
		no: 'Denne måneden',
	},
	'This week': {
		no: 'Denne uken',
	},
	'Last quarter': {
		no: 'Forrige kvartal',
	},
	'Last month': {
		no: 'Forrige måned',
	},
	'Last week': {
		no: 'Forrige uke',
	},
	'Yesterday': {
		no: 'I går',
	},
	'Last 7 days': {
		no: 'Siste 7 dager',
	},
	'Last 30 days': {
		no: 'Siste 30 dager',
	},
	'RRULE': {
		no: 'Gjentagelse',
	},
	'Delivery type': {
		no: 'Leveringstype',
	},
	'Delivery information': {
		no: 'Leveringsinformasjon',
	},
	'Are you sure you want to remove schedule?': {
		no: 'Er du sikker på at du vil slette planen',
	},
	'Schedule successfully deleted': {
		no: 'Plan er slettet',
	},
	'Please input schedule name': {
		no: 'Sett inn tidsplannavn',
	},
	'Available metrics': {
		no: 'Tilgjengelige metrikker',
	},
	'Report type': {
		no: 'Rapporttype',
	},
	'Are you sure you want to remove reports?': {
		no: 'Vil du slette disse rapportene?',
	},
	'Are you sure you want to remove report?': {
		no: 'Vil du slette rapporten?',
	},
	'Report(s) successfully deleted.': {
		no: 'Rapport er slettet',
	},
	'Override cached report': {
		no: 'Overstyr bufret rapport',
	},
	'Download report': {
		no: 'Last ned rapport',
	},
	'Pagebreak': {
		no: 'Sidebrekk',
	},
	'Font type': {
		no: 'Teksttype',
	},
	'Show separator': {
		no: 'Vis skilletegn',
	},
	'Text string': {
		no: 'Tekst',
	},
	'Page break on each item': {
		no: 'Sidebrekk på hvert element',
	},
	'Exclude periods': {
		no: 'Eksluderingsperioder',
	},
	'History details': {
		no: 'Historikk detaljer',
	},
	'Health threshold': {
		no: 'Helseterskel',
	},
	'Hide threshold': {
		no: 'Skjul grenseverdi',
	},
	'Health reason limit': {
		no: 'RessurshelseÅrsåksgrense',
	},
	'Health details': {
		no: 'Helsedetaljer',
	},
	'Current summary': {
		no: 'Gjeldende sammendrag',
	},
	'Sort on compliance': {
		no: 'Sorter på samsvar',
	},
	'Breaches only': {
		no: 'Bare brudd',
	},
	'History summary': {
		no: 'Historikk sammendrag',
	},
	'Service root cause': {
		no: 'Tjenestebrudd sammendrag',
	},
	'Daily aggregate': {
		no: 'Daglig aggregert',
	},
	'Breach details': {
		no: 'Brudd detaljer',
	},
	'Servicelog entries': {
		no: 'Tjenestelogg oppføringer',
	},
	'Breach overview': {
		no: 'Bruddoversikt',
	},
	'Date format': {
		no: 'Datoformat',
	},
	'Display charts with no data': {
		no: 'Vis grafer uten data',
	},
	'Automatic unit scaling': {
		no: 'Automatisk enhetsskalering',
	},
	'Asset title': {
		no: 'Ressurstittel',
	},
	'Multichart': {
		no: 'Multigraf',
	},
	'Low range': {
		no: 'Lavt område',
	},
	'Graph type': {
		no: 'Graftype',
	},
	'Chart mode': {
		no: 'Graftype',
	},
	'Graph height': {
		no: 'Graf høyde',
	},
	'High range': {
		no: 'Høyt område',
	},
	'Graph width': {
		no: 'Graf bredde',
	},
	'Sort ascending': {
		no: 'Sorter stigende',
	},
	'Compliance filter(%)': {
		no: 'Samsvarsfilter(%)',
	},
	'Show 3D': {
		no: 'Vis 3D',
	},
	'Show current state': {
		no: 'Vis gjeldene status',
	},
	'Show monitor calculation': {
		no: 'Vis monitorkalkulering ',
	},
	'Show asset calculation': {
		no: 'Vis ressurskalkulering',
	},
	'Show service element info': {
		no: 'Vis tjeneste element info',
	},
	'Show servicequalifier info': {
		no: 'Vis tjenestepunkt info',
	},
	'Service breach overview': {
		no: 'Tjenestebrudd oversikt',
	},
	'Service breach summary': {
		no: 'Tjenestebrudd sammendrag',
	},
	'Service element breach overview': {
		no: 'Tjenesteelementbrudd oversikt',
	},
	'Header type': {
		no: 'Overskrift type',
	},
	'Number Of decimals': {
		no: 'Antall desimaler',
	},
	'Historic periods': {
		no: 'Historiske perioder',
	},
	'Servicequalifier description': {
		no: 'Tjenestepunkt beskrivelse',
	},
	'Report mode': {
		no: 'Rapporttype',
	},
	'Asset filter': {
		no: 'Ressursfilter',
	},
	'Skip if no data': {
		no: 'Ignorere om ingen data',
	},
	'Show account name': {
		no: 'Vis kontonavn',
	},
	'Show unacknowledged only': {
		no: 'Vis bare ubekreftede',
	},
	'Show unassigned only': {
		no: 'Vis bare ikke tildelte',
	},
	'Max events': {
		no: 'Maks hendelser',
	},
	'Target filter': {
		no: 'Målfilter',
	},
	'Type filter': {
		no: 'Type filter',
	},
	'Show healthindex': {
		no: 'Vis helseindeks',
	},
	'Health reason Limit': {
		no: 'Helseårsak grense',
	},
	'Health reasons visible': {
		no: 'Helseårsak synlig',
	},
	'Health detail visible': {
		no: 'helsedetaljer synlig',
	},
	'Show detail': {
		no: 'Vis detaljer',
	},
	'Monitor health visible': {
		no: 'Monitorhelse synlighet',
	},
	'Severity filter': {
		no: 'Alvorlighetsfilter',
	},
	'Show as card': {
		no: 'Vis som kort',
	},
	'Last hour changes': {
		no: 'Siste time endringer',
	},
	'Message filter': {
		no: 'Meldingsfilter',
	},
	'Show actionlog': {
		no: 'Vis handlingslogg',
	},
	'Include current events': {
		no: 'Inkluder nåværende hendelser',
	},
	'Include historic events': {
		no: 'Inkluder historiske hendelser',
	},
	'Use vertical Labels': {
		no: 'Bruk stående tekst',
	},
	'Categorize by time': {
		no: 'Kategoriser med tid',
	},
	'Categorize by subsystem': {
		no: 'Kategoriser med subsystem',
	},
	'Categorize by target': {
		no: 'Kategoriser med mål',
	},
	'Categorize by name': {
		no: 'Kategoriser med navn',
	},
	'Categorize by eventtype': {
		no: 'Kategoriser med hendelsetype',
	},
	'Categorize by monitortype': {
		no: 'Kategoriser med monitortype',
	},
	'Show budget': {
		no: 'Vis budsjett',
	},
	'Show cost': {
		no: 'Vis kost',
	},
	'Show total': {
		no: 'Vis total',
	},
	'Show listprice': {
		no: 'Vis listerpris',
	},
	'Ordering month': {
		no: 'Månedsrekkefølge',
	},
	'Current month first': {
		no: 'Vis nåværende måned først',
	},
	'Show in 1000': {
		no: 'Vis i 1000',
	},
	'Query': {
		no: 'Spørring',
	},
	'Show current year': {
		no: 'Vis nåværende år',
	},
	'Top N': {
		no: 'Topp N',
	},
	'Show other': {
		no: 'Vis andre',
	},
	'Listing price': {
		no: 'Listepris',
	},
	'Show estimated cost': {
		no: 'Vis estimert kostnad',
	},
	'Show actual cost': {
		no: 'Vis faktisk kostnad',
	},
	'Show legend': {
		no: 'Vis navneinformasjon',
	},
	'Show title': {
		no: 'Vis tittel',
	},
	'Page break on first item': {
		no: ' Sidebrekk på første element',
	},
};
